import { Link } from "react-router";

export function NotFoundRoute() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 text-center">
      <h1 className="text-2xl font-semibold">Page not found</h1>
      <p className="text-sm text-muted-foreground">
        The page you&apos;re looking for doesn&apos;t exist.
      </p>
      <Link to="/exceptions" className="text-sm text-primary hover:underline">
        Back to exceptions
      </Link>
    </div>
  );
}
